module.exports = __webpack_public_path__ + "static/media/3.8ff5dd57.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/intro/3.png
// module id = 1286
// module chunks = 0